import request from '@/utils/request2'

// 列表(主数据列表)
export function loadAppUserListDataApi(data) {
  return request({
    url: 'tms-web/appUser/listByPage',
    method: 'post',
    data
  })
}

// 导出
export function exportAppUserListDataApi(data) {
  return request({
    url: 'tms-web/appUser/exportByPage',
    method: 'post',
    data
  })
}

// 保存
export function saveAppUserApi(data) {
  return request({
    url: 'tms-web/appUser/save',
    method: 'post',
    data
  })
}

// 作废
export function deleteAppUserApi(data) {
  return request({
    url: 'tms-web/appUser/delete',
    method: 'post',
    data
  })
}

// 查看
export function viewAppUserApi(data) {
  return request({
    url: 'tms-web/appUser/view',
    method: 'post',
    data
  })
}

// 列表
export function listAppUserApi(data) {
  return request({
    url: 'tms-web/appUser/list',
    method: 'post',
    data
  })
}
